import { render, staticRenderFns } from "./BeneficiaryPlate.vue?vue&type=template&id=5f598992&scoped=true&"
import script from "./BeneficiaryPlate.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryPlate.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryPlate.vue?vue&type=style&index=0&id=5f598992&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f598992",
  null
  
)

export default component.exports